<template>
    <tr>
        <td width="25%" v-bind:class="'cat'+appointment.category">{{translateCategory(appointment.category)}}</td>
        <td width="15%">{{appointment.date.format('DD/MM')}}</td>
        <td width="15%">{{appointment.time_start.format('HH:mm')}}</td>
        <td width="15%">{{appointment.time_end.format('HH:mm')}}</td>
        <td width="15%">
            <a 
            href="javascript:;" 
            v-on:mouseover="showInstructorName = true"
            v-on:mouseleave="showInstructorName = false"
            >{{showInstructorName ? appointment.instructor.name:instructorInitials}}</a>
        </td>
        <td width="15%">
            <div class="dotMenu" v-bind:class="{ 'active':showMenu }" v-on:click="showMenu = !showMenu">
                <div class="dropdown">
                    <a href="javascript:;" v-on:click="cancelAppointment();"><span class="lnr lnr-cross"></span> Aflys bookning</a>
                </div>
                <div class="v--modal-overlay" v-if="showMenu"></div>
            </div>
        </td>
    </tr>
</template>

<style lang="scss" scoped>
.v--modal-overlay {
    z-index: 9;
    background: none;
}
.dropdown {
    z-index: 99;
}
</style>


<script>
import appointmentMixin from '@/mixins/appointment.js';

export default {
    props: ['appointment'],
    mixins: [appointmentMixin],

    data: function() {
        return {
            showMenu: false,

            showInstructorName: false,
        }
    },

    created() {
        this.parseAppointment(this.appointment);
    },

    computed: {
        instructorInitials: function() {
            let name = this.appointment.instructor.name.split(' ');
            var initials = '';
            name.forEach(function(element) {
                initials += element.substring(0,1);
            });

            return initials;
        }
    },

    methods: {
        cancelAppointment() {
            this.$emit('cancelAppointment', this.appointment);
        },

        parseAppointment(appointment) {
            let parsedAppointment = appointment;

            parsedAppointment.date = this.$moment(appointment.date);
            parsedAppointment.time_start = this.$moment(appointment.time_start);
            parsedAppointment.time_end = this.$moment(appointment.time_end);
        }
    }
}
</script>

